import React, {useState, useEffect} from 'react';

import {Table} from "../../../common/table/Table";
import {retrieveAllTrainingModules} from "../../../../services/TrainingModuleService";

export const TrainingTopicTable = ({context, setContext, navigateTo, setSpinnerText, showToaster}) => {

    const [trainingTopics, setTrainingTopics] = useState([]);

    useEffect(() => {
        setSpinnerText("Retrieving Training Topics");
        const fetchData = async () => {
            const [data, error] = await retrieveAllTrainingModules(context.username);
            if (data) {
                if (data.responseStatus === "Success") {
                    setTrainingTopics(data.trainingModuleVOList);
                } else {
                    showToaster(data);
                }
            } else {
                showToaster({
                    responseStatus: "Error",
                    responseMessage: error.message,
                });
            }
            setSpinnerText(null);
        }
        fetchData();
    }, []);

    const handleRowClick = (trainingTopic) => {
        setContext((prevState) => ({
            ...prevState,
            selectedTrainingTopic: trainingTopic,
        }))
        navigateTo("trainingTopicCapture");
    }

    const handleAddButtonClick = () => {
        setContext((prevState) => ({
            ...prevState,
            selectedTrainingTopic: null,
        }));
        navigateTo("trainingTopicCapture");
    }

    return (
        <div className="admin-table-container">
            <Table tableData={trainingTopics} buttonText="Add Training Topic" onButtonClick={handleAddButtonClick}
                   onRowClick={handleRowClick} searchEnabled={true} hiddenColumns={["externalReference", "isDeleted", "created", "lastModified"]}/>
        </div>
    );
}
